export default {
  authenticate: {
    sign_in: 'inloggen',
    remember_me: 'herinner mij',
    login: 'aansluiting',
    main_slogan: 'plus que quelques clics pour vous connecter à votre compte',
    secondary_slogan: 'gérez tous vos e-commerce depuis un seul endroit'
  }
}
